/* __next_internal_client_entry_do_not_use__ LoggedOutMobileSignUpSnackbar auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { SignUpSnackbarEvent, useSignUpSnackbarStateMachine } from "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/useSignupSnackbarStateMachine";
import { MobileFixedBanner } from "@faire/retailer-visitor-shared/components/MobileAppSnackbar/MobileFixedBanner";
import { WrappedModal } from "@faire/retailer-visitor-shared/components/MobileAppSnackbar/WrappedModal";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useAssignSettingSignupCTAMobileWebBanner, useSettingSignupCTAMobileWebBanner } from "@faire/retailer-visitor-shared/settings/useSettingSignupCTAMobileWebBanner";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
export var LoggedOutMobileSignUpSnackbar = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isMobile = useViewport().isMobile;
    var history = useHistory();
    var _useSignUpSnackbarStateMachine = useSignUpSnackbarStateMachine(), isSignUpSnackbarDisplayable = _useSignUpSnackbarStateMachine.isSignUpSnackbarDisplayable, updateSignUpSnackbarState = _useSignUpSnackbarStateMachine.updateSignUpSnackbarState;
    var showSignupCTAMobileWebBanner = useSettingSignupCTAMobileWebBanner();
    var assignSettingSignupCTAMobileWebBanner = useAssignSettingSignupCTAMobileWebBanner();
    var dismissModal = function() {
        updateSignUpSnackbarState(SignUpSnackbarEvent.DISMISSED);
    };
    var handleCTAClick = function() {
        popSignUp(history, SignUpType.GENERIC, function() {}, {
            element: SignUpElement.SNACKBAR,
            sourceId: "logged_out_mobile_sign_up_snackbar"
        });
        dismissModal();
    };
    useEffect(function() {
        // on dismount, if the user is eligible to see the snackbar
        //   we want to store the state so that the snackbar is shown on next page load
        return function() {
            updateSignUpSnackbarState(SignUpSnackbarEvent.NAVIGATED);
        };
    }, [
        updateSignUpSnackbarState
    ]);
    var shouldShowSnackbar = isMobile && isSignUpSnackbarDisplayable;
    useEffect(function() {
        if (shouldShowSnackbar) {
            // assign XP when user is eligible to see the snackbar
            assignSettingSignupCTAMobileWebBanner();
        }
    }, [
        assignSettingSignupCTAMobileWebBanner,
        shouldShowSnackbar
    ]);
    return /*#__PURE__*/ _jsx(WrappedModal, {
        ariaHideApp: false,
        bottom: 0,
        isOpen: shouldShowSnackbar && showSignupCTAMobileWebBanner,
        showOverlay: false,
        children: /*#__PURE__*/ _jsx(MobileFixedBanner, {
            message: strictLocalize({
                id: "TwJxkj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Signup to unlock wholesale prices for your store"
                    }
                ]
            }),
            ctaText: strictLocalize({
                id: "zfxluM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up for free"
                    }
                ]
            }),
            ctaAction: handleCTAClick,
            closeAction: dismissModal,
            mediumMessageFont: true,
            noIcon: true,
            cornerButton: true
        })
    });
};
